export const VERIFICATION_MODAL_SHOW = 'VERIFICATION_MODAL_SHOW'
export const SET_TASK_COMPLETE_MODAL = 'SET_TASK_COMPLETE_MODAL'
